import { Link } from "@StarberryUtils";
import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Container, Row, Button } from 'react-bootstrap';
import PlayVideo from "../Play/custom-video";
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import ImageModule from "../common/Image_Module";
import _ from 'lodash'
import "./AreaGuides.scss";

const AreaGuides = (props) => {

	const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    areaGuides(where: {Publish: true}) {
	      id
	      Title
	      URL
	      Video_URL
		  ggfx_results {
            id
            src_cftle
            src_url
            transforms
            updatedAt
            createdAt
            _id
    }
	      Tile_Image {
	        url
	        alternativeText
	      }
	      imagetransforms
	    }
      }
    }
  `);

	const area_guides = data.glstrapi.areaGuides
	const [isLess, setLess] = useState(false);
	const [render, setRender] = useState(false);
	const [loadMoreList, setLoadMoreList] = useState([]);
	var intialNumberOfReview = 8;
	useEffect(() => {
		if(!render){
			setRender(true);
			setLess(false);
			setLoadMoreList(_.clone(area_guides).slice(0, 8))
		}
	
	})
	const loadMore = () => {
	
		let primeryLength = loadMoreList.length;
		let newList = area_guides.slice(
			0,
			primeryLength + intialNumberOfReview
		);
		setLoadMoreList(newList);
		if (newList.length === area_guides.length) {
			setLess(true);
		} else {
			setLess(false);
		}
	}; 
	return (
		<div className="area-guide-lisiting-wrapper sec-pdb-120">
			<Container>
				<Row>
					{loadMoreList && loadMoreList.map((data, i) => {

						const image_url = data.Tile_Image.url

						let processedImages = JSON.stringify({});
						if (data?.imagetransforms?.Tile_Image_Transforms) {
							processedImages = data.imagetransforms.Tile_Image_Transforms;
						}

						return (
							<div className="col-md-6 col-lg-4 col-xl-3 guide-card-wrap">
								<Link to={data.URL}>
									<div className="tile">
										<div className="guide-image-video img-zoom">
											{data.Tile_Image &&
												// <ImageTransform 
												// imagesources={image_url} 
												// renderer="srcSet" 
												// imagename="area-guides.Tile_Image.tile" 
												// attr={{ alt: data.Title + ' - Dacha', class: '' }} 
												// imagetransformresult={processedImages} 
												// id={data.id} />
												<ImageModule 
                                                ImageSrc={data?.Tile_Image} 
                                                attr={{ alt: data.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={data?.ggfx_results} 
                                                imagename="area-guides.Tile_Image.tile"
                                                strapi_id={data?.id} 
                                            />  
											}
										</div>
										{/* <span className="title">{data.Title}</span> */}
										<div className="d-flex area-guide-info">
											<span className="title text-md-bold">{data.Title}</span>
											{/* <i className="area-arrow"></i> */}
										</div>
									</div>
								</Link>
								{data.Video_URL &&
									<div className="banner-btn">
										<PlayVideo url={data.Video_URL}
										/>
									</div>
								}
							</div>
						)
					})}
				
				</Row>
				{area_guides && area_guides.length > 10 && !isLess ? (
					<div className="d-flex justify-content-center load-more-btn">
						<Button variant="outline" onClick={loadMore}>
							Load More
						</Button>
					</div>
				) : null}
			</Container>
		</div>
	)
}

export default AreaGuides